import { useState, useEffect } from 'react';

// false on the server AND on the client's first (hydration) render; true after.
//
// Use this to defer browser-only rendering instead of branching on
// `typeof window !== 'undefined'` in a render body. That branch evaluates
// differently on the server than on the client's first render, which is exactly
// what breaks hydration (React #418). Gating on this hook keeps the first render
// identical on both sides and moves the browser-only output to a second pass.
const useHasMounted = () => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return hasMounted;
};
export default useHasMounted;
